import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBlogs, deleteBlog } from "../../../../utils/redux/blog/blogActions";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const BlogListingPage = () => {
    const dispatch = useDispatch();
    const { blogs } = useSelector(state => state.blog);

    useEffect(() => {
        dispatch(fetchBlogs());
    }, []);

    const handleDelete = async (id) => {
        if (!window.confirm("Delete blog?")) return;
        const res = await dispatch(deleteBlog(id));
        if (res?.success) toast.success("Deleted");
    };

    return (
        <div className="container">
            <div className="d-flex justify-content-between my-4">
                <h3>Blogs</h3>
                <Link to="/create-blog" className="btn btn-primary">
                    + Add Blog
                </Link>
            </div>

            <table className="table">
                <thead>
                    <tr>
                        <th>Title</th>
                        <th>Category</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {blogs?.map(b => (
                        <tr key={b._id}>
                            <td>
                                <Link to={`/blogs/${b._id}`}>{b.title}</Link>
                            </td>
                            <td>{b.category?.name}</td>
                            <td>
                                <Link to={`/blogs/${b._id}/edit`} className="btn btn-sm btn-primary me-2">
                                    Edit
                                </Link>
                                <button
                                    className="btn btn-sm btn-danger"
                                    onClick={() => handleDelete(b._id)}
                                >
                                    Delete
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default BlogListingPage;